module.exports = __webpack_public_path__ + "img/your-pdb.c54834f6.svg";